import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    prefix: {
        type: String,
        default: "iconfont"
    },
    fontSize: {
        type: Number,
        default: 24
    },
    iconClass: {
        type: String,
        required: false
    },
    color: {
        type: String
    }
},
  setup(__props) {

const props = __props;



const className = computed(() => `${props.prefix} ${props.iconClass}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["use-icon", _unref(className)]),
    style: _normalizeStyle({ 'font-size': __props.fontSize + 'px', color: __props.color })
  }, null, 6 /* CLASS, STYLE */))
}
}

})